'use strict';

import Price from "../../ValueObjects/Price/Price";
import User from "../User/User";
import PaymentType from "./PaymentType";

export default class PaymentItem {

    id = undefined;
    paymentType = undefined;
    amountReceived = undefined;
    paymentDate = '';
    created = '';
    createdBy = undefined;
    modified = '';
    modifiedBy = undefined;

    static blank() {
        return new PaymentItem();
    }

    static fromApi(item) {
        const entity = PaymentItem.blank();

        // Construct from expected API output object
        // Note: `is_logged_in` will not be set for the below Users, access via Client object
        entity.id = item.id;
        entity.paymentType = item.payment_type ? PaymentType.fromApi(item.payment_type) : undefined;
        entity.amountReceived = item.amount_received ? Price.fromApi(item.amount_received) : undefined;
        entity.paymentDate = item.payment_date;
        entity.created = item.created;
        entity.createdBy = item.created_by ? User.fromApi(item.created_by) : undefined;
        entity.modified = item.modified;
        entity.modifiedBy = item.modified_by ? User.fromApi(item.modified_by) : undefined;

        return entity;
    }

    static select(entityArray, id) {
        return entityArray.find(entity => entity.matches(id));
    }

    matches(id) {
        return String(this.id) === String(id);
    }

    clone() {
        return Object.assign(PaymentItem.blank(), this);
    }

}
